import React, { useState, useEffect, useRef } from "react";
import InvertorForm from "./InvertorForm";
import Pagination from "../../../utils/pagination/Pagination";
import { Trash2, SquarePen, Eye, Plus } from "lucide-react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Spinner,
  Button,
  ModalCloseButton,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getInventoryInvertor } from "../../../redux/reduxApi/InventoryInvertorReduxApi";
// import { countInventory } from '../../../redux/api/inventoryApi/InventoryApi';
import { countInventoryInverter } from "../../../redux/api/inventoryApi/InventoryInvertorApi";
// import { deleteInventory } from '../../../redux/api/inventoryApi/InventoryApi';
import { deleteInventoryInverter } from "../../../redux/api/inventoryApi/InventoryInvertorApi";
// import { deleteinventoryAction } from '../../../redux/reduxSlice/InventorySlice';
import { deleteInventoryInvertorAction } from "../../../redux/reduxSlice/InventoryInvertorSlice";
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import NonSolarItem from "./NonSolarItem";
import EllipsisMenu from "../../../utils/EllipsisDropdown/EllipsisMenu";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../utils/commonFunction/CommonFunction";

function InvertorList(sidebarColor) {
  const desktopRef = useRef(null);
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [isOpen, setIsOpen] = useState(false);
  const [inventoryROWID, setInventoryROWID] = useState("");
  const dispatch = useDispatch();
  const inventoryInvertorData = useSelector((state) => state?.inventoryInvertor?.inventoryInvertor);
  console.log("inventoryInvertorData", inventoryInvertorData);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [deleteInventoryInverterROWID, setDeleteInventoryInverterROWID] = useState("");
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [dataToEdit, setDataToEdit] = useState({});
  //to show add & delete button according to permissions
  const permissions = localStorage.getItem("permissions");
  const filterData = JSON.parse(permissions);
  const getInverterList = useSelector((state) => state.utils.getInverterList);
  console.log("getInverterList", getInverterList);
  const brandList = useSelector((state) => state.utils.brandList);

  // get Inventory
  useEffect(() => {
    setLoading(true);
    dispatch(getInventoryInvertor(currentPage))
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching Inventory data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, dispatch]);

  const fetchTotalCount = async () => {
    try {
      const response = await countInventoryInverter();
      console.log("API Response:", response.data);
      const count = parseInt(response.data.count, 10);
      setTotalCount(count);
    } catch (error) {
      console.error("Error fetching total Inventory count:", error);
    }
  };

  const handleNewData = () => {
    fetchTotalCount();
  };

  useEffect(() => {
    fetchTotalCount();
  }, []);

  // Handle row deletion
  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    const idsToDelete = selectedRows.length === 0 ? [deleteInventoryInverterROWID] : selectedRows;
    Promise.all(idsToDelete.map((id) => deleteInventoryInverter(id)))
      .then(() => {
        setSelectedRows([]);
        dispatch(deleteInventoryInvertorAction(idsToDelete));
        toast.success("Row deleted successfully");
        fetchTotalCount();
      })
      .catch(() => {
        toast.error("Row not deleted");
      })
      .finally(() => {
        setIsOpen(false);
        setDeleteInventoryInverterROWID("");
        setShowProgressBar(false);
        setLoading(false);
      });
  };

  // Modal for delete confirmation
  const openTrash = (ROWID) => {
    setDeleteInventoryInverterROWID(ROWID);
    setIsOpen(true);
  };

  const closeTrash = () => {
    setIsOpen(false);
    setDeleteInventoryInverterROWID("");
  };

  // Handle row selection
  const handleRowSelect = (ROWID) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows.includes(ROWID);
      const updatedRows = isSelected ? prevSelectedRows.filter((id) => id !== ROWID) : [...prevSelectedRows, ROWID];
      console.log("Selected rows:", updatedRows);
      return updatedRows;
    });
  };

  // Handle "select all" functionality
  const handleSelectAllRows = () => {
    setSelectedRows((prevSelectedRows) => {
      const updatedRows = prevSelectedRows.length === inventoryInvertorData?.length ? [] : inventoryInvertorData.map((item) => item?.ROWID);

      console.log("Selected rows:", updatedRows);
      return updatedRows;
    });
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const getInvertoryType = (owner) => {
    const inverterTypeData = getInverterList.filter((item) => item?.ROWID === owner);
    return inverterTypeData[0]?.inverterName;
  };

  const getBrandType = (owner) => {
    const brandTypeData = brandList.filter((item) => item?.ROWID === owner);
    return brandTypeData[0]?.solarBrandName;
  };

  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      {showProgressBar && <ProgressBar colorScheme="pink" />}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <ModalFooter>
            <Button className="create-button" mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={closeTrash}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <div>
        <div ref={desktopRef}>
          <div className="d-flex justify-content-end">
            {selectedRows.length === 0 && (
              <>
                {filterData?.find((mod) => mod.moduleName === "Inventory" && mod.add === true) && (
                  <button className="new-button mx-2" style={{ backgroundColor: sidebarColor }} onClick={openDrawer}>
                    <Plus size="18px" />
                    <span className="ms-1">New</span>
                  </button>
                )}
              </>
            )}
          </div>
          {selectedRows.length > 0 && (
            <>
              {filterData?.find((mob) => mob.moduleName === "Inventory" && mob.delete === true) && (
                <div className="align-items-left mt-2 d-flex gap-2">
                  <button className="new-button" onClick={openTrash}>
                    Delete All
                  </button>
                </div>
              )}
            </>
          )}
        </div>
        <div className="custom-scroll  " style={{ overflow: "scroll", minheight: "75vh" }}>
          <TableContainer
            className="card card-detail mt-1 scrollable-container"
            style={{ maxHeight: "67vh", backgroundColor: "#EFEFEF", border: "none", position: "relative", overflowY: "scroll", scrollbarColor: "#A0AEC0 #EDF2F7", scrollbarWidth: "10px" }}
          >
            <Table variant="simple" size="sm" style={{ whiteSpace: "nowrap", position: "relative", backgroundColor: "white" }}>
              <Thead>
                <Th className="py-1 th-color" style={{ width: "50px" }}>
                  <Checkbox isChecked={selectedRows?.length === inventoryInvertorData?.length} onChange={handleSelectAllRows} />
                </Th>
                <Th className="py-1 th-color" style={{ width: "50px" }}>
                  Action
                </Th>
                <Th className="py-1 th-color" style={{ width: "50px" }}>
                  Name
                </Th>
                <Th className="py-1 th-color" style={{ width: "50px" }}>
                  Product Code
                </Th>
                {/* <Th className='py-1 th-color' style={{ width: '50px' }}>Brand Name</Th> */}
                <Th className="py-1 th-color" style={{ width: "50px" }}>
                  Invertor Type
                </Th>
                <Th className="py-1 th-color" style={{ width: "50px" }}>
                  KW
                </Th>
                <Th className="py-1 th-color" style={{ width: "50px" }}>
                  Selling Price
                </Th>
                <Th className="py-1 th-color" style={{ width: "50px" }}>
                  Purchase Price
                </Th>
                <Th className="py-1 th-color" style={{ width: "50px" }}>
                  Created Time
                </Th>
                <Th className="py-1 th-color" style={{ width: "50px" }}>
                  Modified Time
                </Th>
                <Th className="py-1 th-color" style={{ width: "50px" }}>
                  Created By
                </Th>
              </Thead>
              <Tbody>
                {inventoryInvertorData &&
                  inventoryInvertorData.slice((currentPage - 1) * 30, currentPage * 30).map((item, index) => (
                    <Tr key={index} className="tr-border" style={{ cursor: "pointer", position: "relative" }}>
                      <Td>
                        <Checkbox isChecked={selectedRows.includes(item?.ROWID)} onChange={() => handleRowSelect(item?.ROWID)} />
                      </Td>

                      <Td style={{ width: "110px", textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                        <EllipsisMenu
                          item={item}
                          onView={() => navigate("/inventory-inverter-detail", { state: { ROWID: item?.ROWID } })}
                          onEdit={() => {
                            openDrawer(item);
                            setDataToEdit(item);
                            setIsUpdateMode(true);
                          }}
                          onDelete={() => {
                            openTrash();
                            setDeleteInventoryInverterROWID(item?.ROWID);
                          }}
                          permissions={{
                            canEdit: filterData?.find((mod) => mod.moduleName === "Inventory" && mod.modifyAll === true),
                            canDelete: filterData?.find((mod) => mod.moduleName === "Inventory" && mod.delete === true),
                            canView: true, // Usually always true, but you can make this dynamic too
                          }}
                        />
                      </Td>
                      <Td>{item?.name}</Td>
                      <Td>{item?.productCode}</Td>
                      {/* <Td>{getBrandType(item?.brandName || 'NA')}</Td> */}
                      <Td>{getInvertoryType(item?.invertorType || "NA")}</Td>
                      <Td>{item?.KW || "KW"}</Td>
                      <Td>{item?.sellingPrice}</Td>
                      <Td>{item?.purchasePrice}</Td>
                      <Td>{formatDate(item?.CREATEDTIME)}</Td>
                      <Td>{formatDate(item?.MODIFIEDTIME)}</Td>
                      <Td>{item?.createdBy || "-"}</Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
        <div className="footer">
          <div className="footer d-flex fixed-bottom start-20">
            <div className="total" style={{ marginLeft: "16%", marginTop: "15px" }}>
              <p className="fw-semibold">Total Count: {totalCount}</p>
            </div>

            <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
              <Pagination totalPages={Math.ceil(totalCount / 30)} onPageChange={setCurrentPage} />
            </div>

            <InvertorForm
              closeDrawer={closeDrawer}
              isUpdateMode={isUpdateMode}
              assetROWID={inventoryROWID}
              isDrawerOpen={isDrawerOpen}
              setIsUpdateMode={setIsUpdateMode}
              dataToEdit={dataToEdit}
              onNewDataAdded={handleNewData}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default InvertorList;
